import React from "react";
import { motion } from "framer-motion";
import { FaProcedures, FaMicroscope, FaCapsules, FaClinicMedical, FaHospitalAlt, FaUserMd } from "react-icons/fa";
import { useTranslation } from "react-i18next";


const Facilities = () => {
  const { t } = useTranslation();

  const facilities = [
    {
      title: t("facilities_list.icu"),
      icon: <FaProcedures className="text-red-600 text-4xl" />,
    },
    {
      title: t("facilities_list.lab"),
      icon: <FaMicroscope className="text-blue-600 text-4xl" />,
    },
    {
      title: t("facilities_list.pharmacy"),
      icon: <FaCapsules className="text-purple-600 text-4xl" />,
    },
    {
      title: t("facilities_list.opd"),
      icon: <FaClinicMedical className="text-pink-500 text-4xl" />,
    },
    {
      title: t("facilities_list.wards"),
      icon: <FaHospitalAlt className="text-green-600 text-4xl" />,
    },
    {
      title: t("facilities_list.experts"),
      icon: <FaUserMd className="text-orange-500 text-4xl" />,
    },
  ];
  
  return (
    <section id="Servicies" className="py-20 bg-white px-4">
    <div className="max-w-6xl mx-auto text-center">
      <motion.h2
        className="text-3xl md:text-4xl font-bold text-purple-700 mb-8"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {t("facilities_title")}
      </motion.h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {facilities.map((facility, index) => (
          <motion.div
            key={index}
            className="bg-gray-100 p-6 rounded-xl shadow-md hover:shadow-xl transition"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <div className="mb-4 flex justify-center">{facility.icon}</div>
            <h4 className="text-xl font-semibold text-purple-800">{facility.title}</h4>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
  );
};

export default Facilities;
